import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getSupplySourceTags(adExchanges: TargetingBaseType['adExchanges'] | undefined): TagItem[] {
  const blacklistedCount = adExchanges?.filter(ad => ad.blacklisted).length ?? 0;
  const hasCustomDistribution = adExchanges?.some(ad => ad.distribution !== 0) ?? false;
  const result: TagItem[] = [];
  if (hasCustomDistribution) {
    result.push({ label: 'Custom distribution' });
  }
  if (blacklistedCount > 0) {
    result.push({ label: `${blacklistedCount} blacklisted` });
  }

  return result;
}
